<template>
  <div class="outer sub" id="wrapper">
    <div class="container-fluid">
      <div class="row" style="padding-top: 75px; padding-bottom: 70px">
        <div class="col-md-6 col-lg-6 offset-md-1 offset-lg-1">
          <h2 style="padding-bottom: 25px">{{ $t("book.title") }}</h2>
          <p>{{ $t("book.content1") }}</p>
          <br />
          <p>{{ $t("book.content2") }}</p>
          <br />
          <p>{{ $t("book.content3") }}</p>
          <br />
          <p>{{ $t("book.content4") }}</p>
        </div>
        <div class="col-md-1 col-lg-1"></div>
        <div class="col-md-4 col-lg-4">
          <!-- <iframe TableFever  data-tablefever-widget src="https://widget.tablefever.com/src/widget-v-4/app/dist/index.html"></iframe> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "BodyBook",
};
</script>
